import Microgame from '../engine/Microgame.js';

export default class HoldGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: 'Hold !', en: 'Hold!', es: '¡Mantén!' },
            controls: { fr: 'Maintiens ton doigt (ou clic) appuyé sur l\'empreinte', en: 'Hold your finger (or click) on the fingerprint', es: 'Mantén el dedo en la huella' },
            objective: { fr: 'Remplis la barre de progression avant la fin du temps', en: 'Fill the progress bar before time runs out', es: 'Llena la barra antes de que se acabe el tiempo' },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line><circle cx="12" cy="11" r="3"></circle></svg>`,
            actions: [
                { type: 'hold', x: 50, y: 50, duration: 250, holdDuration: 1400 },
                { type: 'wait', duration: 500 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.isHolding = false;
        this.progress = 0;
        this.holdTime = 2000; // 2 seconds to win
        this.button = null;
        this.progressBar = null;
        this.progressFill = null;
    }

    setup() {
        this.engine.ui.instruction.textContent = "HOLD!";
        this.holdTime = this.engine.maxTime * 0.35; // Hold for 35% of the total time (easier to beat at high speeds)

        // Create Hold Button
        this.button = document.createElement('div');
        this.button.style.position = 'absolute';
        this.button.style.top = '50%';
        this.button.style.left = '50%';
        this.button.style.transform = 'translate(-50%, -50%)';
        this.button.style.width = '150px';
        this.button.style.height = '150px';
        this.button.style.borderRadius = '50%';
        this.button.style.border = `5px solid ${this.primaryColor}`;
        this.button.style.background = 'rgba(0, 243, 255, 0.1)'; // Keep transparent bg or use primary with low opacity? Let's stick to hardcoded low opacity for now or use a helper if available. Actually, let's just use a fixed low opacity white or similar, or try to use primary.
        // Since we don't have a hexToRgba helper readily available in Microgame, let's use a trick or just keep it simple.
        // Let's use the primary color for the border and shadow.
        this.button.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.container.appendChild(this.button);

        // Neon Fingerprint Visual
        const canvas = document.createElement('canvas');
        canvas.width = 100;
        canvas.height = 100;
        canvas.style.pointerEvents = 'none';
        canvas.style.position = 'absolute';
        canvas.style.top = '50%';
        canvas.style.left = '50%';
        canvas.style.transform = 'translate(-50%, -50%)';
        this.button.appendChild(canvas);

        const ctx = canvas.getContext('2d');
        const cx = canvas.width / 2;
        const cy = canvas.height / 2;

        ctx.strokeStyle = this.primaryColor;
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.shadowBlur = 10;
        ctx.shadowColor = this.primaryColor;

        // Draw simplified fingerprint loops
        for (let i = 10; i < 45; i += 8) {
            ctx.beginPath();
            ctx.arc(cx, cy, i, Math.PI, 0); // Top half
            ctx.stroke();

            ctx.beginPath();
            ctx.arc(cx, cy + 5, i, 0, Math.PI); // Bottom half offset
            ctx.stroke();
        }

        // Central whorl
        ctx.beginPath();
        ctx.ellipse(cx, cy, 5, 8, 0, 0, Math.PI * 2);
        ctx.stroke();

        // Progress Ring/Bar
        this.progressBar = document.createElement('div');
        this.progressBar.style.position = 'absolute';
        this.progressBar.style.bottom = '20%';
        this.progressBar.style.left = '50%';
        this.progressBar.style.transform = 'translateX(-50%)';
        this.progressBar.style.width = '200px';
        this.progressBar.style.height = '20px';
        this.progressBar.style.background = '#333';
        this.progressBar.style.borderRadius = '10px';
        this.progressBar.style.overflow = 'hidden';
        this.container.appendChild(this.progressBar);

        this.progressFill = document.createElement('div');
        this.progressFill.style.width = '0%';
        this.progressFill.style.height = '100%';
        this.progressFill.style.background = this.secondaryColor;
        this.progressFill.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        this.progressBar.appendChild(this.progressFill);

        // Events
        this.onDown = this.onDown.bind(this);
        this.onUp = this.onUp.bind(this);

        this.button.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
        this.engine.input.element.addEventListener('pointerleave', this.onUp);
    }

    onDown(e) {
        this.isHolding = true;
        this.button.style.background = 'rgba(0, 243, 255, 0.4)';
        this.button.style.transform = 'translate(-50%, -50%) scale(0.95)';
    }

    onUp(e) {
        this.isHolding = false;
        this.button.style.background = 'rgba(0, 243, 255, 0.1)';
        this.button.style.transform = 'translate(-50%, -50%) scale(1)';
        this.progress = 0; // Reset progress on release
        this.progressFill.style.width = '0%';
    }

    update(dt) {
        if (this.isHolding && this.active) {
            this.progress += dt;
            const pct = Math.min(100, (this.progress / this.holdTime) * 100);
            this.progressFill.style.width = `${pct}%`;

            if (this.progress >= this.holdTime) {
                this.win();
            }
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
        this.engine.input.element.removeEventListener('pointerleave', this.onUp);
    }
}
